const { Game } = require('./js/Game');
new Game(document.querySelector('.game'));
